import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Coins, Workflow } from "lucide-react";
import { PageHeader } from "@/components/domain/misc";
import { Page } from "@/components/layout/page";
import { RouteTabs } from "@/components/layout/route-tabs";

export const Route = createFileRoute("/_app/outcomes")({
  component: OutcomesLayout,
});

function OutcomesLayout() {
  return (
    <Page>
      <PageHeader
        title="Outcomes"
        description="Whether sessions succeed, where that verdict comes from, and what it's worth. Ground truth (your events and business systems) always wins over an inferred outcome."
      />
      <RouteTabs
        tabs={[
          { href: "/outcomes", label: "Outcomes", icon: <Workflow />, exact: true },
          { href: "/outcomes/economics", label: "Economics", icon: <Coins /> },
        ]}
      />
      <Outlet />
    </Page>
  );
}
